





























import { Component, Vue, Prop } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import { RootGettersReturns } from '../../../store/types';
import { ElementActionsKeys, ElementActionsPayload } from '../../../store/types/element';
import { StageActionsKeys, StageActionsPayload } from '../../../store/types/stageState';

@Component({})
export default class AudioToolbar extends Vue {
  @Prop(Boolean) playing!: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Prop(Object) player!: any;

  @Getter selectedElement!: RootGettersReturns['selectedElement'];
  @Getter focusState!: RootGettersReturns['focusState'];
  @Getter isGuest!: RootGettersReturns['isGuest'];
  @Getter sharedBoard!: RootGettersReturns['sharedBoard'];
  @Action(ElementActionsKeys.UPDATE_ELEMENT) updateElement!: (payload: ElementActionsPayload['UPDATE_ELEMENT']) => void;
  @Action(StageActionsKeys.SET_FOCUS) focus!: (payload: StageActionsPayload['SET_FOCUS']) => void;

  get videoPlay() {
    const play = {
      icon: 'mdi-play',
      text: 'Play',
    };
    if (this.playing) {
      play.icon = 'mdi-pause';
      play.text = 'Stop';
    }
    return play;
  }

  togglePlaying() {
    if (this.playing) {
      this.player.pauseVideo();
    } else {
      this.player.playVideo();
    }
  }

  deleteElement() {
    if (!this.selectedElement) return;
    this.updateElement({
      ...this.selectedElement,
      deleted: true,
    });
  }

  focusElement() {
    if (!this.selectedElement) return;
    this.focus({ board_element: this.focusState ? null : this.selectedElement, withPrevState: true });
  }
}
